import { useArticleRoutes } from "./routes";
import { DateTimeViewer, GetDefaultIndex } from "../../components";
import { useGetArticleCommonInfoQuery } from "../../features/articles/articlesSlice";
import { ArticleCommonInfoModel } from "../../entities/articles";
import { Descriptions } from "antd";

export { useArticleRoutes };

export default GetDefaultIndex({
  title: "مقالات",
  query: useGetArticleCommonInfoQuery,
  generalInfoPresentor: (info: ArticleCommonInfoModel) =>
    info ? (
      <Descriptions size="small" column={{ xxl: 4, xl: 3, lg: 2, md: 2, sm: 1, xs: 1 }}>
        <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
          {info.totalRecords}
        </Descriptions.Item>
        <Descriptions.Item label="در حال نگارش" labelStyle={{ color: "gray" }}>
          {info.totalWritingRecords}
        </Descriptions.Item>
        <Descriptions.Item label="بازبینی" labelStyle={{ color: "gray" }}>
          {info.totalRevisionRecords}
        </Descriptions.Item>
        <Descriptions.Item label="درخواست انتشار" labelStyle={{ color: "gray" }}>
          {info.totalPublishingRecords}
        </Descriptions.Item>
        <Descriptions.Item label="منتشر شده" labelStyle={{ color: "gray" }}>
          {info.totalPublishedRecords}
        </Descriptions.Item>
        <Descriptions.Item label="آخرین بازبینی" labelStyle={{ color: "gray" }}>
          <DateTimeViewer value={info.lastRevisionAt} mode="distance" />
        </Descriptions.Item>
        <Descriptions.Item label="آخرین درخواست انتشار" labelStyle={{ color: "gray" }}>
          <DateTimeViewer value={info.lastPublishingAt} mode="distance" />
        </Descriptions.Item>
        <Descriptions.Item label="آخرین انتشار" labelStyle={{ color: "gray" }}>
          <DateTimeViewer value={info.lastPublishedAt} mode="distance" />
        </Descriptions.Item>
        <Descriptions.Item label="آخرین اضافه" labelStyle={{ color: "gray" }}>
          <DateTimeViewer value={info.lastCreateAt} mode="distance" />
        </Descriptions.Item>
        <Descriptions.Item label="آخرین ویرایش" labelStyle={{ color: "gray" }}>
          <DateTimeViewer value={info.lastUpdateAt} mode="distance" />
        </Descriptions.Item>
      </Descriptions>
    ) : null,
});
